import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import PartnerCalendar from './components/Calendar/PartnerCalendar.vue'
import HomePageContainer from '@/components/Views/Home/HomePageContainer'
import ListPageContainer from '@/components/Views/List/ListPageContainer'
import ObjectPageContainer from '@/components/Views/ObjectPageContainer'
import ArticleContainer from '@/components/Views/Home/ArticleContainer'

Vue.use(Meta)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/*_page.html',
      component: ArticleContainer,
      name: 'article',
      props: (route) => {
        const urlParts = route.path.split('_')
        return {
          lang: urlParts[urlParts.length - 2],
          id: urlParts.filter((urlPart, index) => index <= urlParts.length - 3).join('_').replace('/', '')
        }
      }
    },
    {
      path: '/*_object.html',
      component: ObjectPageContainer,
      name: 'object',
      props: (route) => {
        const urlParts = route.path.split('_')
        return {
          lang: urlParts[urlParts.length - 2],
          id: urlParts.filter((urlPart, index) => index <= urlParts.length - 3).join('_').replace('/', '')
        }
      }
    },
    {
      path: '/',
      name: 'home',
      component: HomePageContainer,
    },
    {
      path: '/:lang',
      name: 'homewlang',
      component: HomePageContainer,
    },
    {
      path: '/:lang/article/:articleId',
      name: 'article',
      component: ArticleContainer,
    },
    {
      path: '/:lang/calendar/:objectId',
      name: 'calendar',
      component: PartnerCalendar,
    },
    {
      path: '/:lang/search/:query',
      name: 'search',
      component: ListPageContainer,
    },
    {
      path: '/:lang/object/:object_id',
      name: 'object',
      component: ObjectPageContainer,
    },
    {
      path: '/:lang/*',
      name: 'homewlang',
      component: HomePageContainer,
    },
  ]
})

export default router
